<mat-table
  [dataSource]="items"
  [trackBy]="trackBy"
  matSort
  matSortDisableClear
  multiTemplateDataRows
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
  class="table container-fluid"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef class="test">Appliance Name</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <div *ngIf="item.name">
        <span>{{ item.name }}</span>
        <sn-icon fontIcon="fa-server" fontSet="fa-solid"></sn-icon>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="deviceStatus">
    <mat-header-cell *matHeaderCellDef>Appliance Status</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <div class="appliaceStatus" *ngIf="item.reportMeta.chargeControllerMeta">
        <span>{{ item.reportMeta.chargeControllerMeta.status }}</span>
        <sn-icon fontIcon="fa-hard-drive" fontSet="fa-solid"></sn-icon>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="voltageStatus">
    <mat-header-cell *matHeaderCellDef>Appliance Voltage Status</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <div class="appliaceStatus" *ngIf="item.reportMeta.chargeControllerMeta">
        <span>{{ item.reportMeta.chargeControllerMeta.loadVoltage }}</span>
        <sn-icon
          [fontIcon]="setVoltageIcon(item.reportMeta.chargeControllerMeta.loadVoltage)"
          fontSet="fa-solid"
          [style]="setVoltageStyle(item.reportMeta.chargeControllerMeta.loadVoltage)"
        ></sn-icon>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Actions</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list
        [items]="actions"
        [context]="item"
        alwaysExpand
        onSmallScreen
      ></sn-action-list>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="extended-details">
    <mat-cell
      *matCellDef="let item"
      [attr.colspan]="columns.length"
      [class.isExpanded]="isExpanded(item.id)"
    >
      <div class="detail" [@snDetailExpand]="isExpanded(item.id) ? 'expanded' : 'collapsed'">
        <div *ngIf="isExpanded(item.id)">
          <div class="extended-details">
            <fs-map class="map-wrapper" [zoom]="19" (mapInit)="onMapInit($event)"></fs-map>
            <sn-appliances-charger-control
              class="charger-control-wrapper"
              [appliance]="appliance"
            ></sn-appliances-charger-control>
          </div>
        </div>
      </div>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="toggleExpanded(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
  <mat-row *matRowDef="let row; columns: ['extended-details']" class="detail-row"></mat-row>
</mat-table>
